var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPills(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M529.125 206.844C466.75 144.48 365.25 144.355 302.75 206.844C240.25 269.334 240.25 370.691 302.75 433.18C365.25 495.543 466.625 495.668 529.125 433.18S591.625 269.209 529.125 206.844ZM321.75 259.709L476.25 414.184C375.75 478.672 257 360.441 321.75 259.709ZM510.25 380.189L355.75 225.715C456.25 161.102 575 279.457 510.25 380.189ZM112 32C50.125 32 0 82.115 0 143.98V367.941C0 429.805 50.125 479.922 112 479.922S224 429.805 224 367.941V143.98C224 82.115 173.875 32 112 32ZM176 255.961H48V143.98C48 59.244 176 59.244 176 143.98V255.961Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPills);
export default __webpack_public_path__ + "static/media/pills.acd61b83dd992bc0f328fdb04ffaf627.svg";
export { ForwardRef as ReactComponent };